export const periodModes = {
    day: 'day',
    week: 'week',
    month: 'month',
};

